(() => {
  const root = document.querySelector('[data-fp-root]');
  if (!root || root.dataset.bound) return;
  root.dataset.bound = 'true';
  let quantity = 1, ready = false;
  const prices = {1:99000, 2:159000, 3:189000};
  const buttons = [...root.querySelectorAll('[data-fp-buy]'), ...document.querySelectorAll('[data-fp-sticky-buy]')];
  const mobile = document.querySelector('[data-fp-mobile]');
  const status = root.querySelector('[data-fp-status]'), retry = root.querySelector('[data-fp-retry]');
  const fail = () => {
    ready = false;
    buttons.forEach(button => button.disabled = true);
    status.textContent = 'No pudimos confirmar las ofertas. Vuelve a cargar para continuar.';
    retry.hidden = false;
  };
  const update = () => {
    const total = prices[quantity].toLocaleString('es-CO');
    root.querySelector('[data-fp-label]').textContent = `COMPRAR ${quantity * 3} SOBRES · $${total}`;
    document.querySelector('[data-fp-mobile-summary]').textContent = `${quantity * 3} sobres · $${total}`;
  };
  const activate = () => {
    document.querySelectorAll('.fsj-inline,.fsj-sticky').forEach(button => button.style.setProperty('display','none','important'));
    const data = window.__fsjOffers;
    if (typeof window.__fsjOpenOrder !== 'function' || data?.productHandle !== root.dataset.productHandle) return false;
    if (![1,2,3].every(n => data.offers?.some(offer => offer.active && Number(offer.quantity) === n && Number(offer.price) === prices[n]))) { fail(); return true; }
    ready = true;
    buttons.forEach(button => button.disabled = false);
    retry.hidden = true;
    status.textContent = 'Revisa el combo y completa tus datos de entrega.';
    return true;
  };
  root.querySelectorAll('[name="fp-package"]').forEach(input => input.addEventListener('change', () => { quantity = Number(input.value); update(); }));
  buttons.forEach(button => button.addEventListener('click', () => { if (ready) window.__fsjOpenOrder({productHandle:root.dataset.productHandle,quantity}); }));
  retry.addEventListener('click', () => window.location.reload());
  window.addEventListener('fsj:ready', activate);
  window.addEventListener('fsj:offers', activate);
  let tries = 0;
  const timer = setInterval(() => { if (activate()) clearInterval(timer); else if (++tries >= 60) { clearInterval(timer); fail(); } }, 250);
  activate();
  update();
  const mainButton = root.querySelector('[data-fp-buy]');
  new IntersectionObserver(entries => { mobile.hidden = entries[0].isIntersecting; }, {threshold:0.2}).observe(mainButton);
  document.addEventListener('click', event => {
    const offer = event.target.closest('#fsj-root [data-fsj-qty]');
    if (!offer) return;
    const next = Number(offer.dataset.fsjQty);
    if (!prices[next]) return;
    quantity = next;
    root.querySelectorAll('[name="fp-package"]').forEach(input => input.checked = Number(input.value) === quantity);
    update();
  });
})();
